import { useQuery } from "@tanstack/react-query";
import api from "../api";

export function nearbyQueryKey(category, latitude, longitude, radius) {
  return ["nearby", category, latitude, longitude, radius];
}

async function fetchNearbyResults({ category, latitude, longitude, radius }) {
  const response = await api.get(process.env.REACT_APP_NEARBY_URL, {
    params: {
      lat: latitude,
      lng: longitude,
      radius,
      limit: 50,
      type: category === "eventy" ? "events" : "places",
    },
  });

  return response.data ?? {};
}

export function useNearbyQuery({ category, location, radius, enabled }) {
  return useQuery({
    queryKey: nearbyQueryKey(category, location?.lat, location?.lng, radius),
    queryFn: () => fetchNearbyResults({
      category,
      latitude: location.lat,
      longitude: location.lng,
      radius,
    }),
    enabled,
    staleTime: 30_000,
  });
}
